module.exports = __webpack_public_path__ + "static/media/analytics.49e75f3c.png";